import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../axios";

export const categoryApi = createAsyncThunk(
  "category/list",
  async ({ limit, skip } = {}, { rejectWithValue }) => {
    try {
      return axios
        .get("/categories", { params: { limit, skip } })
        .then((response) => {
          const apiData = response?.data;
          // Ensure consistent shape; fall back to mock if empty/invalid
          // return MOCK_CATEGORIES;

          return apiData;
        })
        .catch((error) => {
          const errorObject = error?.response?.data || {
            message: error.message || "Failed to fetch categories",
          };
          return rejectWithValue(errorObject);
        });
    } catch (error) {
      return rejectWithValue({
        message: "Unexpected error while fetching categories",
      });
    }
  }
);
